import type { ChattengerServiceWorkerMessage } from '@/interfaces/Pwa';
import { getNavigatorOrNull, getWindowOrNull } from '@/lib/browser/runtime';
import { getPublicAssetPath } from '@/lib/config/webApp';

export const CHATTENGER_SERVICE_WORKER_PATH = '/chattenger-web-sw.js';
export const CHATTENGER_SERVICE_WORKER_SCOPE = '/';

const getBuildMarker = () => String(process.env.NEXT_PUBLIC_CHATTENGER_BUILD_MARKER ?? '').trim();

const postServiceWorkerMessage = (worker: ServiceWorker | null | undefined, message: ChattengerServiceWorkerMessage) => {
    if (!worker) {
        return;
    }

    worker.postMessage(message);
};

export const canUseChattengerServiceWorker = () => {
    const browserNavigator = getNavigatorOrNull();
    const browserWindow = getWindowOrNull();

    return Boolean(browserNavigator && browserWindow && 'serviceWorker' in browserNavigator && browserWindow.isSecureContext !== false);
};

export const registerChattengerServiceWorker = async () => {
    const browserNavigator = getNavigatorOrNull();
    if (!canUseChattengerServiceWorker() || !browserNavigator || !('serviceWorker' in browserNavigator)) {
        return null;
    }

    const registration = await browserNavigator.serviceWorker.register(getPublicAssetPath(CHATTENGER_SERVICE_WORKER_PATH), {
        scope: CHATTENGER_SERVICE_WORKER_SCOPE,
    });

    const buildMarker = getBuildMarker();
    if (buildMarker) {
        postServiceWorkerMessage(registration.active ?? registration.waiting ?? registration.installing, {
            type: 'CHATTENGER_BUILD_MARKER',
            buildMarker,
        });
    }

    return registration;
};
